<template>
  <!-- 遮照广告 -->
<!-- <section class="adBox" v-if="showCoupon && mbMaskingAds.perm" @touchmove.prevent @click.stop="catchClick">
  <section :class="['adBox_bg',showCoupon?'opacity':'']"></section> -->
  <section class="adBox_main">
    <section class="adBox_main_t" v-if="mbMaskingAds.maskType == 1">
      <img class="couponBg"  src="../assets/images/advertisement_bg.png">
      <section class="adBox_main_t_text">
        <section class="coupon_detail">
          <img class="coupon_bg" src="../assets/images/advertisement_quanbg.png">
          <section class="coupon_detail_left">
            <p class="log" v-if="mbMaskingAds.discountMode == 1">¥</p>
            <p class="money">{{mbMaskingAds.amountDiscount}}</p>
            <p class="log" v-if="mbMaskingAds.discountMode == 2">折</p>
          </section>
          <section class="coupon_detail_right">
            <p class="coupon_detail_right_title">{{mbMaskingAds.bondName}}</p>
            <p class="date_range">{{mbMaskingAds.beginTime}}-{{mbMaskingAds.endTime}} </p>
            <p class="date_instr line2">{{mbMaskingAds.descr}}</p>
          </section>
        </section>
      </section>
      <img @click.stop="getCoupon" src="../assets/images/advertisement_button.jpg" class="coupon_btn_img" />
    </section>
    <img v-if="mbMaskingAds.maskType == 0" @click.stop="picAdver" class="coupon_img" :src="mbMaskingAds.imgPath">
    <img @click.stop="closeCoupon" class="coupon_delect" src="../assets/images/icon_popup_close.png" >
  </section>
<!-- </section> -->
</template>
<script type="text/javascript">
export default {
  name: 'advertising',
  props: {
    showCoupon: {
      type: Boolean,
      default: false
    },
    mbMaskingAds: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
    };
  },
  created () {},
  methods: {
    catchClick () {
    },
    getCoupon () {
      this.$emit('getCoupon')
    },
    closeCoupon () {
      this.$emit('closeCoupon')
    },
    picAdver () {
      let link = this.mbMaskingAds.maskLink;
      console.log(link)
       if (link.indexOf("http:") > -1 ||link.indexOf("https:") > -1) {
            // 跳转网页地址
            localStorage.setItem("src",link)
            this.$router.push(`/iframePage`)
          } else {
            this.$router.push(link);
          }
      // if (link.indexOf('/activityDetails/') > -1) {
      //   // link = link.replace('dist/views/activity/activityDetail.js', '/pages/activityDetail/activityDetail')
      //   this.$router.push(link);
      // } else {
      //   window.location.href = link
      // }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common.less";
/* 遮照广告 */
.adBox{
  position:fixed;
  top:0;bottom:0;right:0;left:0;
  z-index:3;
}
.adBox_bg{
  width:100%;
  height:100%;
  background:rgba(0,0,0,0.5);
  opacity:0;
  transition:all ease 3s;
}
.opacity{
  opacity:1;
}
.adBox_main{
  position: absolute;
  top:50%;left:50%;
  transform:translate(-50%,-50%);
  width:580px;
}
.couponBg{
  width:580px;
  height:756px;
  // background-color: #FA5A1A;
}
.adBox_main_t{
  width:580px;
  height:756px;
  position: relative;
}
.coupon_img{
  display:block;
  width:580px;
  height:756px;
  border-radius:20px;
  object-fit:contain;
}
.adBox_main_t_text{
  position: absolute;
  top:310px;
  left:36px;
  width:508px;
  height:172px;
  z-index:2;
  text-align:center;
}
.coupon_btn_img{
  position: absolute;
  bottom: 40px;
  left:36px;
  width:508px;
  height:160px;
  z-index:2;

}
.coupon_title{
  display:inline-block;
  height:40px;
  .fontSize(14px);
  color:rgba(255,230,197,1);
  line-height:40px;
  padding:0 60px;
  margin:72px auto;
  text-align:center;
  position: relative;
}
.coupon_title:after{
  position: absolute;
  left:0;top:20px;
  content:'';
  height:2px;
  width:40px;
  background:rgba(255,230,197,0.6);
}
.coupon_title:before{
  position: absolute;
  right:0;top:20px;
  content:'';
  height:2px;
  width:40px;
  background:rgba(255,230,197,0.6);
}
.coupon_delect{
  width:68px;
  height:68px;
  display:block;
  // background-color: #FA5A1A;
  margin:40px auto 0;
}
.coupon_detail{
  // margin:0 28px;
  width:508px;
  height:172px;
  display:flex;
  flex-direction:row;
  position: relative;
}
.coupon_bg{
  width:508px;
  height:172px;
  // background-color: #FA5A1A;
  position: absolute;
  object-fit:contain;
  top:0;
}
.coupon_detail_left,.coupon_detail_right{
  position: relative;
  z-index:2;
}
.coupon_detail_right p{
  display:block;
}
.coupon_detail_left{
  width:160px;
  height:180px;
  display:flex;
  flex-direction:row;
  justify-content:center;
  align-items:center;
}
.coupon_detail_left p{
  color:#FA5A1A;
  .fontSize(26px);
}
.coupon_detail_left p.log{
  .fontSize(12px);
  display:block;
  margin-right:4px;
  margin-bottom:15px;
}
.coupon_detail_right{
  flex:1;
  margin-left:10px;
  display:flex;
  flex-direction:column;
  text-align:left;
}
.coupon_detail_right_title{
  height:64px;
  .fontSize(12px);
  color:rgba(51,51,51,1);
  line-height:32px;
  margin-top:28px;
  overflow:hidden;
}
.date_range,.date_instr{
  /* height:28px; */
  .fontSize(10px);
  color:rgba(153,153,153,1);
  line-height:28px;
  margin-bottom:4px;
}
/* .date_instr{
  margin-bottom:14px;
} */
.coupon_btn{
  display:block;
  width:220px;
  height:68px;
  border-radius:38px;
  background:#fff;
  text-align:Center;
  line-height:68px;
  color:#fa5219;
  .fontSize(14px);
  margin:86px auto 0;
}
.line2{
  height:56px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal !important;
  -webkit-line-clamp:2;
  -webkit-box-orient: vertical;
}
</style>